import bgTasksActions from "actions/bgTasks";
import BgTasks from "components/bgTasks";
import { BgTaskTypeValues } from "helpers/bgTasks";
import { workloadStatusesEnum } from "helpers/enums";
import { ReportTypeValues } from "helpers/reports";
import { Moment } from "moment";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Action, ActionFunctionAny } from "redux-actions";

type Keys = keyof typeof workloadStatusesEnum;
export type WorkloadStatusesValues = (typeof workloadStatusesEnum)[Keys];

type BgTask = {
    endDate: Moment;
    key: string;
    reportType: ReportTypeValues;
    startDate: Moment;
    status: WorkloadStatusesValues;
    taskType: BgTaskTypeValues;
    title: string;
};

const mapStateToProps = (state: { bgTasks: { items: BgTask[] } }) => ({
    items: state.bgTasks.items,
});

const mapDispatchToProps = (dispatch: ActionFunctionAny<Action<Object>>) => ({
    add: (params: {}) => dispatch(bgTasksActions.add(params)),
    update: (params: {}) => dispatch(bgTasksActions.update(params)),
    remove: (params: {}) => dispatch(bgTasksActions.remove(params)),
    removeAll: () => dispatch(bgTasksActions.removeAll()),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BgTasks));
